<template>
  <v-card
    flat
    max-width="500"
  >
    <v-card-text>
      <p class="text-2xl font-weight-semibold text--primary mb-2">
        Criar nova senha 🔒
      </p>

      <p class="mb-2">
        Sua nova senha deve ser diferente das senhas criadas anteriormente
      </p>
    </v-card-text>

    <v-card-text>
      <v-form
        ref="formRef"
        @submit.prevent="handleSubmitBtnClick"
      >
        <v-text-field
          v-model="request.cpf"
          v-mask="'###.###.###-##'"
          class="mb-3"
          dense
          outlined
          label="CPF"
          hide-details="auto"
          validate-on-blur
          :rules="[validators.required, validators.isCpfValido]"
        />

        <v-text-field
          v-model="request.chaveLink"
          v-mask="'XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX'"
          class="mb-3"
          dense
          outlined
          label="Chave link"
          hide-details="auto"
          validate-on-blur
          :rules="[validators.required]"
        />

        <v-text-field
          v-model="request.novaSenha"
          class="mb-3"
          dense
          outlined
          label="Nova senha"
          placeholder="············"
          hide-details="auto"
          validate-on-blur
          :type="isPasswordVisible ? 'text' : 'password'"
          :append-icon="isPasswordVisible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline"
          :rules="[validators.passwordValidator, validators.required]"
          @click:append="isPasswordVisible = !isPasswordVisible"
        />

        <v-text-field
          v-model="request.confirmarSenha"
          dense
          outlined
          label="Confirmar senha"
          placeholder="············"
          hide-details="auto"
          validate-on-blur
          :type="isConfirmPasswordVisible ? 'text' : 'password'"
          :append-icon="isConfirmPasswordVisible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline"
          :rules="[
            validators.required,
            validators.passwordValidator,
            validators.confirmedValidator(request.novaSenha, request.confirmarSenha),
          ]"
          @click:append="isConfirmPasswordVisible = !isConfirmPasswordVisible"
        />

        <v-btn
          block
          color="primary"
          class="mt-4"
          type="submit"
          :loading="loading"
        >
          Criar nova senha
        </v-btn>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'
import { confirmedValidator, passwordValidator, required } from '@core/utils/validation'
import router from '@/router'
import ClienteService from '@/services/modules/ClienteService'
import useForm from '@/composables/useForm'
import useCentralStore from '@/store/central'
import { isCpfValido } from '@/utils/validation'

export default {
  setup() {
    const isPasswordVisible = ref(false)
    const isConfirmPasswordVisible = ref(false)
    const { formRef, loading, validateForm } = useForm()
    const { requestUrl } = storeToRefs(useCentralStore())

    const request = ref({
      urlAlias: requestUrl.value,
      cpf: '',
      chaveLink: '',
      novaSenha: '',
    })

    function goToAuthLogin() {
      router.push({ name: 'auth-login' })
    }

    async function handleSubmitBtnClick() {
      if (loading.value) return
      if (!validateForm()) return

      try {
        loading.value = true
        await ClienteService.criarNovaSenha(request.value)
        goToAuthLogin()
      } finally {
        loading.value = false
      }
    }

    return {
      isPasswordVisible,
      isConfirmPasswordVisible,
      formRef,
      loading,
      request,
      handleSubmitBtnClick,
      icons: {
        mdiEyeOutline,
        mdiEyeOffOutline,
      },
      validators: {
        required,
        confirmedValidator,
        passwordValidator,
        isCpfValido,
      },
    }
  },
}
</script>
